import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MButton } from "@/components/ui/atoms/MButtons";
import FormHeader from "@/components/ui/organisms/MHeader";
import { getMemberInfo } from "@/hooks/useMembers";
import MSpacer from "@/components/ui/atoms/MSpacer";
import { trackUserDataLoaded } from "@/utils/gtm";
import {
  ANALYTICS_SCREEN_TYPES,
  ANALYTICS_SCREEN_NAMES,
} from "@/constants/analytics.constants";

const AddMemberInvite: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Try to get nickname/firstName from location state or localStorage
  let firstName = "";
  if (location.state && (location.state.nickname || location.state.firstName)) {
    firstName = location.state.nickname || location.state.firstName;
  } else {
    const saved = localStorage.getItem("add_member_form");
    if (saved) {
      try {
        const form = JSON.parse(saved);
        firstName = form.nickname || form.firstName || "";
      } catch {
        /* noop -- ignore localStorage parse failures, fall back to default */
      }
    }
  }
  const [inviteToggle, setInviteToggle] = useState(false);

  const memberInfo = getMemberInfo(true);

  // Track GTM user_data_loaded event on page load
  React.useEffect(() => {
    if (!memberInfo?.id) return;

    trackUserDataLoaded({
      memberInfo,
      screenType: ANALYTICS_SCREEN_TYPES.FAMILY,
      screenName: ANALYTICS_SCREEN_NAMES.FAMILY_ADD_MEMBER_INVITE_MEMBER,
    });
  }, [memberInfo?.id]);

  return (
    <div className="profile-page-root">
      <FormHeader
        module="Family"
        memberInfo={getMemberInfo()}
        title={`Invite ${firstName} to join your family`}
        description={`They’ll be able to create an account and access shared family health records.`}
      />
      <MSpacer mt={34} />
      <div className="body-base-bold">Would you like to send the invite?</div>
      <div style={{ display: "flex", gap: 20, marginTop: 32 }}>
        <MButton
          variant="outline"
          size="md"
          style={{ width: "48%" }}
          onClick={() => {
            setInviteToggle(false);
            const saved = localStorage.getItem("add_member_form");
            const form = saved ? JSON.parse(saved) : {};
            form.invite = false;
            form.contact_option = ""; // Clear contact_option when user chooses not to invite
            localStorage.setItem("add_member_form", JSON.stringify(form));
            // Navigate directly to consent
            navigate(`/profile/family/add-member/form/details/invite/consent`);
          }}
        >
          No
        </MButton>
        <MButton
          variant="filled"
          size="md"
          style={{ width: "47%" }}
          onClick={() => {
            setInviteToggle(true);
            const saved = localStorage.getItem("add_member_form");
            const form = saved ? JSON.parse(saved) : {};
            form.invite = true;
            localStorage.setItem("add_member_form", JSON.stringify(form));
            // Navigate to contact options
            navigate(`/profile/family/add-member/form/details/invite/contact`);
          }}
        >
          Yes
        </MButton>
      </div>
    </div>
  );
};

export default AddMemberInvite;
